// extracted by mini-css-extract-plugin
module.exports = {"colorClaro":"#fff","colorOscuro":"#1e2128","colorPrimario":"#e82222","colorSecundario":"#122256"};